import { startOfDay, startOfToday } from 'date-fns';

/**
 * Prefer `endDate` / review mode over encounter `isArchived`: that flag is a separate
 * edit-permission concern (`enc?.isArchived`) and is not equivalent to a closed stay.
 * Closed stay = discharged (`endDate`) and/or review-mode UI flag.
 */
export function isClosedEncounterStay(endDate: Date | null | undefined, reviewMode = false): boolean {
    return !!endDate || reviewMode;
}

/**
 * Default day for the encounter calendar / day tables.
 * - Active: today
 * - Discharged / review: admission day (`startDate`) — product expectation (MD-10341)
 * Navigable max day is capped separately via `getEncounterViewDateRange` at `endDate`.
 */
export function getEncounterViewDefaultDate(
    startDate: Date,
    endDate: Date | null | undefined,
    reviewMode = false,
): Date {
    if (isClosedEncounterStay(endDate, reviewMode)) {
        return startOfDay(startDate);
    }
    return startOfToday();
}
